<template>
  <el-form :rules="rules" ref="satcomForm" :model="satcom_config[pickedConfig]" label-width="150px" label-position="left">
    <el-row justify="center">
      <el-col :span="12">
        <el-form-item label="Modem type :" prop="name">
          <el-select v-model="comms.name">
            <el-option
              v-for="(comm,index) in comms_type" :label="comm.label" :key="index"
              :value="comm.value"></el-option>
          </el-select>
          <!--<el-input style="width:70%" v-model="comms.name"/>-->
        </el-form-item>
        <el-form-item label="provider:" prop="name">
          <el-select v-model="pickedConfig">
            <el-option
              v-for="(provider,index) in Object.keys(satcom_config)" :label="provider" :key="index"
              :value="provider"></el-option>
          </el-select>
          <!--<el-input style="width:70%" v-model="comms.name"/>-->
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          label=" URL:" prop="url">
          <el-input v-model="satcom_config[pickedConfig].url" style="padding-right: 10%;"></el-input>
        </el-form-item> <el-form-item
          label=" Token:" prop="token">
          <el-input v-model="satcom_config[pickedConfig].token" style="padding-right: 10%;"></el-input>
        </el-form-item> <el-form-item
          label=" modem Id:" prop="modem_id"
          :rules="[
            { required: true, message: 'modem Id is required'},
            { type: 'number', message: 'modem Id must be a number'}
        ]">
          <el-input type="modem_id" v-model.number="satcom_config[pickedConfig].modem_id" style="padding-right: 10%;"></el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <!--<el-form-item label="Tx :" prop="tx">-->
    <!--<el-input style="width:70%" v-model="comms.tx"/>-->
    <!--</el-form-item>-->
    <!--<el-form-item label="Rx :" prop="rx">-->
    <!--<el-input style="width:70%" v-model="comms.rx"/>-->
    <!--</el-form-item>-->

  </el-form>
</template>

<script>
  import {post} from "../../../../../API/cloudFunctions";

  export default {
    created() {

    },
    name: "Satcom",
    data() {
      return {
        comms_type: [{label: 'IDP-782', value: 'idp'}],
        Providers: [{name: 'Treemetrics'}],
        comms: {
          name: "idp",
          tx: "/dev/ttyUSB2",
          rx: "/dev/ttyUSB2"
        },
        satcom_config: {
          "treemetrics": {
            "url": "",
            "token": "",
            "modem_id": null
          }
        },
        pickedConfig: "treemetrics",
        rules: {
          name: {
            required: true,
            message: "Please provide a Name !"
          },
          apn: {required: true},
          band: {required: true},
          operator: {required: true},
          port: {required: true},
          udp_addr: {required: true},
          udp_port: {required: true},
          url:{required:true},
          token:{required:true}

        },

        loading: false,
        disablePassword: true,
        sendingTestEmail: false,
        sent: false
      };
    },
    methods: {}
  };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/layout/components/profile/configuration/satcom.vue